var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-menu-list-item",class:[("theme-" + _vm.theme)],style:(_vm.styleProps),on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0499af08","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/navigation/nuttrema-menu-list-item.vue
// module id = 2893
// module chunks = 0